import { render, staticRenderFns } from "./TabComponent.vue?vue&type=template&id=492c8788&scoped=true"
import script from "./TabComponent.vue?vue&type=script&lang=js"
export * from "./TabComponent.vue?vue&type=script&lang=js"
import style0 from "./TabComponent.vue?vue&type=style&index=0&id=492c8788&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492c8788",
  null
  
)

export default component.exports